import { ILookupBase } from './lookupBase'
import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

@Injectable()
export class PhysicianTypeODataService extends ODataService<ILookupBase> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'PhysicianTypes'
  }
}
